export default __webpack_public_path__ + "static/media/nightmarecompanions.df54705c.png";